export default {
  // Shokz Inquiry Management
  shokzInquiryManagement: {
    title: 'Shokz Inquiry Management',
    description: 'Shokz - Manage customer inquiry and quotation process',

    // Tabs
    tabs: {
      fcl: 'FCL Inquiry',
      lcl: 'LCL Inquiry',
      air: 'Air Freight Inquiry',
      precarriage: 'Precarriage Inquiry',
      oncarriage: 'Oncarriage Inquiry'
    },

    // LCL Inquiry
    lclInquiryManagement: {
      title: 'LCL Inquiry',
      add: 'New LCL Inquiry'
    },

    // Air Freight Inquiry
    airInquiryManagement: {
      title: 'Air Freight Inquiry',
      add: 'New Air Freight Inquiry'
    },

    // Toolbar buttons
    toolbar: {
      addInquiry: 'New Inquiry',
      addFclInquiry: 'New FCL Inquiry',
      addLclInquiry: 'New LCL Inquiry',
      addAirInquiry: 'New Air Freight Inquiry',
      addPrePortInquiry: 'New Pre-port Inquiry',
      addLastMileInquiry: 'New Last Mile Inquiry',
      batchOperations: 'Batch Operations ({count})',
      batchExport: 'Batch Export',
      batchExportExcel: 'Batch Export Excel',
      batchExportCsv: 'Batch Export CSV',
      batchDelete: 'Batch Delete',
      quotationSummary: 'Quotation Summary'
    },

    // Table column headers
    columns: {
      inquiryNo: 'Inquiry No.',
      quotationNo: 'Quotation No.',
      viewMoreQuotationNos: 'View {count} more quotation numbers',
      source: 'Inquiry Source',
      inquirerId: 'Inquirer',
      inquiryStatus: 'Inquiry Status',
      inquiryNature: 'Inquiry Nature',
      businessType: 'Business Type',
      targetSuppliers: 'Target Suppliers',
      quotedSuppliers: 'Quoted',
      prePortQuotationStatus: 'First-leg Quotation Status',
      trunkLineQuotationStatus: 'Main-leg Quotation Status',
      lastMileQuotationStatus: 'Last-mile Quotation Status',
      validPeriod: 'Valid Period',
      seaEq: 'Container Type & Quantity',
      cargoReadyTime: 'Cargo Ready Time',
      cargoReadyTimeType: 'Cargo Ready Time Type',
      cargoReadyTimeRange: 'Cargo Ready Time Range',
      cargoReadyTimeDate: 'Cargo Ready Time',
      cargoReadyTimeStart: 'Cargo Ready Time Start',
      cargoReadyTimeEnd: 'Cargo Ready Time End',
      totalQuantity: 'Quantity',
      totalWeight: 'Gross Weight(KGS)',
      totalCubage: 'Volume(CBM)',
      status: 'Status',
      quotationStatus: 'Quotation Status',
      palletNature: 'Cargo Nature',
      carrierId: 'Carrier',
      airline: 'Airline',
      directTransit: 'Direct/Transit',
      routeId: 'Route',
      loadingPortId: 'Port of Loading',
      dischargingPortId: 'Port of Discharge',
      destinationPortId: 'Port of Discharge (POD)',
      cargoType: 'Cargo Type',
      weight: 'Weight(KGS)',
      cubage: 'Volume(CBM)',
      quantity: 'Quantity',
      density: 'Density',
      flightNo: 'Flight No.',
      departureAirportId: 'Departure Airport',
      arrivalAirportId: 'Arrival Airport',
      deadLine: 'Deadline',
      etd: 'Expected Departure Date',
      eta: 'Expected Arrival Date',
      serviceTerm: 'Service Term',
      customServiceTerm: 'Custom Service Term',
      clientType: 'Client Type',
      clientTitle: 'Client Name',
      remarks: 'Special Requirements',
      createdBy: 'Created By',
      dateCreated: 'Created Time',
      modifiedBy: 'Modified By',
      dateModified: 'Modified Time',
      cargoTransportMode: 'Cargo Transport Mode',
      actions: 'Actions'
    },

    filters: {
      quotationNo: 'Quotation No.',
      quotationNoPlaceholder: 'Enter quotation number'
    },

    cargoTransportMode: {
      containerFcl: 'Container FCL',
      roro: 'RoRo',
      containerLcl: 'Container LCL',
      bulk: 'Breakbulk'
    },

    // Action buttons
    actions: {
      view: 'View',
      detail: 'Details',
      edit: 'Edit',
      submit: 'Submit',
      revoke: 'Revoke',
      delete: 'Delete',
      more: 'More',
      copy: 'Copy',
      confirmSupplier: 'Confirm Supplier',
      quotationSummary: 'Quotation Summary',
      sendEmail: 'Send Inquiry Email',
      quoteCompare: 'Quote Compare'
    },

    // Status display
    status: {
      draft: 'Draft',
      submitted: 'Submitted',
      sent: 'Sent',
      quoted: 'Quoted',
      confirmed: 'Confirmed',
      closed: 'Closed',
      pending: 'Pending',
      notEnabled: 'Not Enabled',
      rejected: 'Rejected'
    },

    // Confirmation dialogs
    confirmDialog: {
      submitTitle: 'Confirm Submit',
      submitContent: 'Are you sure to submit inquiry "{inquiryNo}"?',
      submitOk: 'Confirm Submit',
      submitCancel: 'Cancel',
      revokeTitle: 'Confirm Revoke',
      revokeContent: 'Are you sure to revoke inquiry "{inquiryNo}" to draft status?',
      revokeOk: 'Confirm Revoke',
      revokeCancel: 'Cancel',
      deleteTitle: 'Confirm Delete',
      deleteContent: 'Are you sure to delete inquiry "{inquiryNo}"?',
      batchDeleteTitle: 'Batch Delete Confirmation',
      batchDeleteContent: 'Are you sure to delete the selected {count} records?'
    },

    // Copy confirmation dialog
    copyConfirm: {
      title: 'Confirm Copy Inquiry',
      description: 'Are you sure you want to copy this inquiry? A new draft inquiry will be created after copying.',
      detailTitle: 'Inquiry Details',
      inquiryNo: 'Inquiry No.'
    },

    // Messages
    messages: {
      dataLoadFailed: 'Failed to load inquiry data',
      selectRecordsFirst: 'Please select records to delete first',
      noDataToExport: 'No data to export',
      exportSuccess: 'Successfully exported {count} records as {type} format',
      exportFailed: 'Failed to export {type} format, please try again later',
      submitSuccess: 'Inquiry submitted successfully',
      submitFailed: 'Submit failed, please try again later',
      revokeSuccess: 'Inquiry has been revoked to draft status',
      revokeFailed: 'Revoke failed, please try again later',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed',
      copySuccess: 'Copy successful',
      copyFailed: 'Copy failed, please try again later',
      batchDeleteSuccess: 'Batch delete successful',
      batchDeleteFailed: 'Batch delete failed',
      alreadyDraft: 'Inquiry is already in draft status, no need to revoke',
      onlySubmittedCanRevoke: 'Only submitted inquiries can be revoked to draft',
      invalidStatusForAction: 'Invalid inquiry status',
      cannotDeleteRecords: 'Submitted inquiries cannot be deleted, please check the selected records'
    },

    // Unread notifications
    notifications: {
      title: 'Notifications',
      prePortQuoted: 'First-leg quoted',
      trunkLineQuoted: 'Main-leg quoted',
      lastMileQuoted: 'Last-mile quoted',
      allQuoted: 'All quotations completed'
    },

    // Custom table modal
    customTableModal: {
      title: 'Custom Table Fields',
      description: 'Select fields to display in the table',
      resetButton: 'Reset'
    },

    // Export
    export: {
      filename: 'Inquiry Data'
    },

    // Detail configuration
    detail: {
      assignType: 'Assignment Target'
    },

    filterPlaceholders: {
      enterInquiryNo: 'Please enter inquiry number',
      selectSource: 'Please select inquiry source',
      selectInquirer: 'Please select inquirer',
      selectStatus: 'Please select inquiry status',
      selectCarrier: 'Please select carrier',
      selectTrunkLineStatus: 'Please select trunk line quote status',
      selectPrePortStatus: 'Please select pre-port quote status',
      selectLastMileStatus: 'Please select last mile quote status',
      selectCargoReadyTimeType: 'Please select cargo ready time type',
      selectCargoReadyTimeRange: 'Please select cargo ready time range',
      selectCargoReadyTimeDate: 'Please select cargo ready time',
      selectPalletNature: 'Please select pallet nature',
      selectDirectTransit: 'Please select direct/transit',
      selectRoute: 'Please select route',
      selectPol: 'Please select port of loading',
      selectPod: 'Please select port of discharge',
      selectDischargingPort: 'Please select port of discharge',
      selectCargoType: 'Please select cargo type',
      selectServiceTerm: 'Please select service terms',
      enterCustomServiceTerm: 'Please enter custom service terms',
      selectClientType: 'Please select client type',
      enterClientTitle: 'Please enter client name',
      enterSeaEq: 'Please enter container info',
      enterRemarks: 'Please enter remarks',
      selectDepartureAirport: 'Please select departure airport',
      selectArrivalAirport: 'Please select arrival airport',
      selectFlightNo: 'Please select flight no.',
      inputFlightNo: 'Please enter flight no.',
      selectDateCreated: 'Please select creation time range',
      selectDateModified: 'Please select modification time range',
      selectCreatedBy: 'Please select created by',
      selectModifiedBy: 'Please select modified by'
    }
  },

  // Shokz Inquiry Detail Page
  shokzInquiryDetail: {
    // Page titles
    pageTitle: {
      create: 'New Inquiry',
      edit: 'Inquiry Detail',
      view: 'Inquiry Detail',
      loading: 'Loading...'
    },

    // Form sections
    sections: {
      basicInfo: 'Basic Information',
      cargoInfo: 'Cargo Information',
      loadingPoint: 'Loading Point',
      deliveryAddress: 'Last Mile Delivery Address',
      containerInfo: 'Container Type & Quantity',
      matchPrice: 'Matched Prices',
      fclPrice: 'FCL Prices',
      prePortPrice: 'Preport Prices',
      lastMilePrice: 'Last Mile Prices',
      supplierQuotation: 'Supplier Quotation'
    },

    // Checkbox options
    checkboxes: {
      prePortPrice: 'Preport Price',
      trunkLinePrice: 'Trunk Line Price',
      lastMilePrice: 'Last Mile Price'
    },

    // Attachments
    attachments: {
      title: 'Attachments',
      titleRequired: 'Attachments *',
      tip: 'Supports uploading documents, images, compressed files, etc. Max 20MB per file, up to 20 files.'
    },

    // Action buttons
    actions: {
      saveDraft: 'Save Draft',
      exportRate: 'Export Rate',
      exportQuotation: 'Export Quotation',
      submit: 'Publish Now',
      directSubmit: 'Submit Directly',
      cancel: 'Cancel',
      back: 'Back',
      aiRecognition: 'AI Recognition',
      addContainerType: 'Add Container Type',
      matchPrice: 'Query Matched Prices',
      reset: 'Reset',
      quoteCompare: 'Quote Compare'
    },

    form: {
      titles: {
        createFcl: 'New Ocean FCL Inquiry',
        editFcl: 'Edit Ocean FCL Inquiry',
        viewFcl: 'View Ocean FCL Inquiry',
        createLcl: 'New Ocean LCL Inquiry',
        editLcl: 'Edit Ocean LCL Inquiry',
        viewLcl: 'View Ocean LCL Inquiry',
        createAir: 'New Air Inquiry',
        editAir: 'Edit Air Inquiry',
        viewAir: 'View Air Inquiry',
        createPrePort: 'New Inquiry',
        editPrePort: 'Edit Inquiry',
        createLastMile: 'New Inquiry',
        editLastMile: 'Edit Inquiry'
      },
      tags: {
        prePort: 'Pre-port Rate PrePort',
        lastMile: 'Last Mile Rate LastMile'
      },
      sections: {
        basicInfo: 'Basic Information',
        cargoGroup: 'Cargo Group',
        loadingInfo: 'Loading Location Information',
        arrivalNodeInfo: 'Arrival Node Information',
        destinationPortInfo: 'Port of Discharge Information',
        loadingPortInfo: 'Origin Port Information',
        destinationInfo: 'Destination Information',
        prePortLoadingPoint: 'Pre-port Loading Point',
        lastMileDeliveryAddress: 'Last Mile Delivery Address',
        matchResult: 'Matched Rate Results'
      },
      labels: {
        inquiryNature: 'Inquiry Nature',
        inquirer: 'Inquirer',
        transportTerms: 'Transport Terms',
        serviceTerm: 'Service Terms',
        loadingPort: 'Port of Loading',
        destinationPort: 'Port of Discharge (POD)',
        carrier: 'Carrier',
        airline: 'Airline',
        transportType: 'Transport Type',
        transportMode: 'Transport Mode',
        directTransit: 'Direct/Transit',
        transferPort: 'Transfer Port',
        cargoReadyTime: 'Cargo Ready Time',
        cargoReadyDate: 'Cargo Ready Date',
        cargoReadyRange: 'Cargo Ready Time Range',
        cargoType: 'Cargo Type',
        cargoName: 'Cargo Name',
        unNo: 'UN Number',
        hazardClass: 'Hazard Class',
        hsCode: 'HS Code',
        cargoValue: 'Cargo Value',
        quoteDeadline: 'Quotation Deadline',
        etd: 'Expected Departure Date',
        eta: 'Expected Arrival Date',
        quantity: 'Quantity',
        grossWeight: 'Gross Weight(KGS)',
        volume: 'Volume(CBM)',
        density: 'Density',
        packageType: 'Package Type',
        packageMode: 'Packaging Mode',
        palletSize: 'Pallet Size(LxWxH) CM',
        palletQuantity: 'Pallet Quantity',
        remarks: 'Special Requirements',
        paymentType: 'Payment Type',
        originCountries: 'Origin Countries',
        originCities: 'Origin Cities',
        destinationCountries: 'Destination Countries',
        destinationCities: 'Destination Cities',
        departureAirportTerminal: 'Departure Airport Terminal',
        arrivalAirportTerminal: 'Arrival Airport Terminal',
        prePortTransportMode: 'Pre-port Transport Mode',
        prePortArrivalNodeType: 'Pre-port Arrival Node',
        lastMileOriginNodeType: 'Discharge Node Type',
        loadingCity: 'Loading City',
        loadingRailwayStation: 'Loading Railway Station',
        arrivalCountry: 'Arrival Country',
        arrivalCity: 'Arrival City',
        arrivalSeaport: 'Arrival Seaport',
        arrivalTerminal: 'Arrival Terminal',
        arrivalRailwayStation: 'Arrival Railway Station',
        arrivalAirport: 'Arrival Airport',
        airportTerminal: 'Airport Terminal',
        originCountry: 'Discharge Country',
        originCity: 'Discharge City',
        originSeaport: 'Port of Discharge (POD)',
        originTerminal: 'Discharge Terminal',
        originRailwayStation: 'Discharge Railway Station',
        originAirport: 'Discharge Airport',
        destinationCountry: 'Destination Country',
        destinationCity: 'Destination City',
        destinationSeaport: 'Destination Seaport',
        destinationRailwayStation: 'Destination Railway Station',
        prePortAddressType: 'Pre-port Address Type',
        lastMileTransportMode: 'Last-mile Transport Mode',
        warehouse: 'Warehouse',
        legacyAirportPickup: 'Legacy address information (airport pickup)',
        country: 'Country',
        province: 'Province/State',
        city: 'City',
        cityName: 'City',
        district: 'District/County',
        street: 'Street',
        streetTown: 'Street/Town',
        townStreet: 'Town/Street',
        community: 'Community',
        postalCode: 'Postal Code',
        detailAddress: 'Detailed Address',
        deliveryType: 'Delivery Type',
        deliveryAddressType: 'Delivery Address Type',
        fbaCode: 'FBA Code',
        warehouseCode: 'Warehouse Code(FBA)',
        ecang: 'Ecang',
        ecangWarehouse: 'Ecang Warehouse',
        destinationAirport: 'Destination Airport',
        departureAirport: 'Departure Airport',
        loadingCountry: 'Origin Country',
        originCountryOrLocation: 'Origin Country/Location',
        destinationCountryOrLocation: 'Destination Country/Location',
        terminalYard: 'Terminal/Yard',
        destinationTerminal: 'Destination Terminal',
        loadingTerminal: 'Origin Terminal',
        expectedDeliveryTime: 'Expected Delivery Time',
        rateNo: 'Rate No.',
        supplier: 'Supplier',
        validPeriod: 'Valid Period',
        voyage: 'Transit Time',
        currentPrice: 'Current Quote',
        expectedPrice: 'Expected Price',
        negotiationNote: 'Negotiation Note',
        replyPrice: 'Reply Price',
        replyNote: 'Reply Note',
        changeContent: 'Change Content'
      },
      columns: {
        feeName: 'Fee Name',
        billingMethod: 'Billing Method',
        unitPrice: 'Unit Price',
        currency: 'Currency'
      },
      options: {
        inquiry: 'Inquiry',
        realOrder: 'Actual Order',
        direct: 'Direct',
        transit: 'Transit',
        unspecified: 'Unspecified',
        date: 'Date',
        range: 'Range',
        generalCargo: 'General Cargo',
        magnetic: 'Magnetic',
        battery: 'Battery',
        magneticBattery: 'Magnetic Battery',
        carton: 'Carton',
        woodenCase: 'Wooden Case',
        pallet: 'Pallet',
        wovenBag: 'Woven Bag',
        bulkCargo: 'Bulk Cargo',
        dryContainer: 'Dry Container',
        reeferContainer: 'Reefer Container',
        openTopContainer: 'Open Top Container',
        thirdPartyAddress: 'Third-party Address',
        warehouse: 'Warehouse',
        inlandPoint: 'Inland Point',
        prepaid: 'Prepaid',
        collect: 'Collect',
        prepaidOrCollect: 'Prepaid / Collect',
        truck: 'Truck',
        trailer: 'Trailer',
        barge: 'Barge',
        rail: 'Rail',
        seaport: 'Seaport',
        railwayStation: 'Railway Station',
        airport: 'Airport',
        amazonWarehouse: 'Amazon Warehouse',
        ecang: 'Ecang',
        airportPickup: 'Airport Pickup',
        yes: 'Yes',
        no: 'No'
      },
      placeholders: {
        select: 'Please select',
        inputServiceTerm: 'Enter service term',
        selectLoadingPort: 'Please select port of loading',
        selectDestinationPort: 'Please select port of discharge',
        selectCarrier: 'Please select carrier',
        selectAirline: 'Please select airline',
        selectTransferPort: 'Please select transfer port(s)',
        selectDestinationTerminalYard: 'Discharge terminal or yard',
        selectDepartureAirport: 'Please select departure airport',
        selectArrivalAirport: 'Please select arrival airport',
        searchPort: 'Search port',
        searchPortName: 'Search by port name',
        optionalCarrier: 'Optional',
        multipleSelect: 'Multiple selection supported',
        selectDate: 'Select date',
        inputCargoName: 'Please enter cargo name',
        inputHsCode: 'Please enter HS Code',
        customsCode: 'Customs code',
        customsCode8: 'Customs code, 8 digits',
        declaredValue: 'Declared value',
        cargoValue: 'Cargo value',
        inputQuantity: 'Quantity',
        inputGrossWeight: 'Gross Weight(KGS)',
        inputGrossWeightShort: 'Gross Weight',
        inputVolume: 'Volume',
        inputRemarks: 'Please enter remarks (up to 500 characters)',
        remarkTip: 'Supplementary note shown on the forwarder quotation page',
        inputPostalCode: 'Please enter postal code',
        inputOrSelectPostalCode: 'Please enter or select postal code',
        inputDetailAddress: 'Please enter detailed address',
        fillDetailAddress: 'Please fill in detailed address',
        doorFloorPosition: 'Door/Floor/Specific location',
        selectEcang: 'Please select Ecang',
        selectWarehouse: 'Please select a warehouse',
        fbaExample: 'For example: LAX9, ONT8',
        fbaCode: 'Please enter FBA warehouse code, e.g. LAX9, ONT8'
      },
      buttons: {
        delete: 'Delete',
        addCargoGroup: 'Add Cargo Group',
        matchPrice: 'Query Matched Rates',
        negotiate: 'Negotiate',
        importPriceLib: 'Import'
      },
      summary: {
        totalQuantity: 'Total Quantity',
        totalWeight: 'Total Gross Weight',
        totalVolume: 'Total Volume',
        density: 'Density'
      },
      match: {
        noMatchedPrice: 'No matched rates',
        trunkLineRate: 'Main-leg Rate',
        prePortRate: 'Pre-port Rate',
        lastMileRate: 'Last Mile Rate',
        noTrunkLineRate: 'No matched main-leg rate',
        noPrePortRate: 'No matched pre-port rate',
        noLastMileRate: 'No matched last-mile rate',
        clickMatchPrice: 'Click "Query Matched Rates" to get rates',
        day: 'days'
      },
      negotiation: {
        title: 'Negotiation Records',
        empty: 'No negotiation records'
      }
    },

    detail: {
      loading: 'Loading...',
      backToList: 'Back to List',
      export: 'Export',
      inquiryInfo: 'Inquiry Information',
      inquiryNoWithValue: 'Inquiry No.: {no}',
      sentSuppliersWithCount: 'Sent Suppliers ({count})',
      contact: 'Contact',
      quotedAt: 'Quoted At',
      fields: {
        inquiryNature: 'Inquiry Nature',
        transportTerms: 'Transport Terms',
        serviceTerm: 'Service Term',
        cargoType: 'Cargo Type',
        loadingPort: 'Loading Port',
        loadingPortForLastMile: 'Loading Port',
        dischargingPort: 'Discharging Port',
        destinationPort: 'Port of Discharge (POD)',
        carrier: 'Carrier',
        airline: 'Airline',
        directTransit: 'Transport Mode',
        cargoReadyTime: 'Cargo Ready Time',
        quoteDeadline: 'Quote Deadline',
        cargoDescription: 'Cargo Description',
        cargoValue: 'Cargo Value',
        createdBy: 'Created By',
        createdAt: 'Created At',
        remarks: 'Special Requirements',
        cargoGroupCount: 'Cargo Groups',
        quantity: 'Pieces',
        totalTonnage: 'Total Tonnage',
        grossWeight: 'Gross Weight',
        volume: 'Volume',
        packingMode: 'Packaging',
        departureAirport: 'Origin Airport',
        arrivalAirport: 'Destination Airport',
        chargeableWeight: 'Chargeable Weight',
        loadingAddress: 'Origin Address',
        terminal: 'Terminal',
        destinationAddress: 'Destination Address',
        expectedDeliveryDate: 'Expected Delivery Date',
        transportMode: 'Transport Mode'
      },
      units: {
        piece: 'pcs'
      },
      businessTypes: {
        fcl: 'FCL',
        lcl: 'LCL',
        air: 'Air Freight',
        prePort: 'Pre-port Rate',
        lastMile: 'Last-mile Rate'
      },
      status: {
        draft: 'Draft',
        submitted: 'Submitted',
        completed: 'Completed'
      },
      inquiryNature: {
        pricing: 'Pricing',
        formal: 'Formal Inquiry'
      },
      directTransit: {
        direct: 'Direct',
        transit: 'Transit',
        unspecified: 'Unspecified'
      },
      cargoTypes: {
        general: 'General Cargo',
        magnetic: 'Magnetic',
        battery: 'Battery',
        magneticBattery: 'Magnetic & Battery'
      },
      cargoReadyRanges: {
        oneWeek: 'Within one week',
        twoWeeks: 'Within two weeks',
        oneMonth: 'Within one month',
        moreThanOneMonth: 'More than one month',
        unknown: 'Unknown',
        threeDays: 'Within three days'
      },
      packingModes: {
        dry: 'Dry Container',
        reefer: 'Reefer Container',
        openTop: 'Open Top Container'
      },
      supplierStatus: {
        imported: 'Imported',
        quoted: 'Quoted',
        rejected: 'Rejected',
        pendingQuote: 'Pending Quote'
      }
    },

    // Basic information fields
    basicInfo: {
      inquiryNo: 'Inquiry No.',
      inquirerId: 'Inquirer',
      inquiryNature: 'Inquiry Nature',
      businessType: 'Business Type',
      deadline: 'Quote Deadline',
      palletNature: 'Pallet Nature',
      cargoReadyTime: 'Cargo Ready Time',
      palletQuality: 'Pallet Quality',
      serviceTerm: 'Service Term',
      client: 'Client',
      directTransit: 'Transport Mode',
      detailAddress: 'Detail Address',
      cargoTransportMode: 'Cargo Transport Mode',
      onePriceSupported: 'All In Price',
      onePriceSupportedTip: 'When enabled, All In is selected by default for supplier quotations. Suppliers can deselect it.'
    },

    // Cargo information fields
    cargoInfo: {
      directTransit: 'Direct/Transit',
      route: 'Route',
      loadingPort: 'Loading Port',
      destinationPort: 'Port of Discharge (POD)',
      dischargingPort: 'Discharging Port',
      transitPort1: 'Transit Port (1st)',
      transitPort2: 'Transit Port (2nd)',
      transitPort3: 'Transit Port (3rd)',
      cargoType: 'Cargo Type',
      hazardClass: 'Hazard Class',
      unNo: 'UN No.',
      temperature: 'Temperature',
      ventilation: 'Ventilation',
      quantity: 'Quantity',
      cargoQuantity: 'Cargo Quantity',
      weight: 'Weight',
      weightUnit: 'Weight Unit',
      dimensions: 'Dimensions',
      dimensionsUnit: 'Dimensions Unit',
      length: 'Length',
      width: 'Width',
      height: 'Height',
      cargoDescription: 'Cargo Description (HS Code)',
      containerRequirement: 'Container Requirement',
      transportTerms: 'Transport Terms',
      cargoValue: 'Cargo Value',
      cargoValueCurrency: 'Currency',
      carrier: 'Carrier',
      flightNo: 'Flight No.',
      remarks: 'Special Requirements'
    },

    // Loading point fields
    loadingPoint: {
      selectArea: 'Select Loading Point Area',
      postalCode: 'Postal Code',
      stuffingTerminal: 'Stuffing Terminal/Yard',
      stuffingTerminalPlaceholder: 'Please select terminal/yard',
      deliveryTerminal: 'Delivery Terminal/Yard',
      deliveryTerminalPlaceholder: 'Please select terminal/yard',
      country: 'Country',
      province: 'Province/State',
      city: 'City',
      district: 'District/County',
      street: 'Street/Town',
      community: 'Community',
      stuffingSection: 'Pre-port Stuffing Point',
      stuffingCountry: 'Country',
      stuffingProvince: 'Province/State',
      stuffingCity: 'City',
      stuffingDistrict: 'District/County',
      stuffingStreet: 'Township/Town/Street',
      stuffingCommunity: 'Community',
      detailAddress: 'Detail Address',
      assignType: 'Assign Target'
    },

    // Delivery address fields
    deliveryAddress: {
      addressInfo: 'Delivery Address Information',
      addressType: 'Delivery Address Type',
      postalCodeAndCountry: 'Postal Code & Country',
      country: 'Select country',
      postalCode: 'Enter or select postal code',
      provinceCity: 'Province/State/City',
      province: 'Province/State',
      city: 'City',
      district: 'District',
      detailAddress: 'Detail Address',
      amazonWarehouse: 'Amazon Warehouse Selection',
      ecangWarehouse: 'Ecang Warehouse Selection'
    },

    // Container information fields
    containerInfo: {
      containerType: 'Container Type',
      quantity: 'Quantity',
      containerTypeAndQuantity: 'Container Type & Quantity: ',
      rfTemperatureRequirement: 'Temperature Requirement',
      rfVentilationRequirement: 'Ventilation Requirement',
      temperatureRange: 'Enter temperature range, e.g.: -20 to 30',
      temperatureStart: 'Start Temperature',
      temperatureEnd: 'End Temperature',
      ventilationDoor: 'Ventilation Door',
      ventilationOpen: 'Open',
      ventilationClose: 'Close',
      ventilationVolume: 'Air Flow',
      ventilationVolumeUnit: 'CBM/H',
      ventilationVolumePlaceholder: 'Enter air flow',
      humidity: 'Humidity',
      humidityPlaceholder: 'Please enter humidity',
      humidityUnit: '%RH',
      needPrecooling: 'Need Pre-cooling',
      needPrecoolingYes: 'Yes',
      needPrecoolingNo: 'No',
      temperatureTo: 'to',
      cargoQuantity: 'Quantity',
      weight: 'Weight',
      weightUnit: 'Weight Unit',
      dimensions: 'Dimensions',
      dimensionsUnit: 'Dimensions Unit',
      length: 'Length',
      width: 'Width',
      height: 'Height',
      temperatureUnit: '℃'
    },

    roro: {
      title: 'Vehicle Information',
      vehicleType: 'Vehicle Type',
      quantity: 'Quantity',
      brand: 'Brand',
      model: 'Model',
      dimensions: 'Dimensions (L×W×H) M',
      weightKgs: 'Gross Weight (KGS)',
      remarks: 'Remarks',
      addVehicle: 'Add Vehicle',
      totalQuantity: 'Total Quantity',
      totalWeight: 'Total Gross Weight',
      totalRlm: 'RLM',
      vehicleUnit: 'vehicles',
      dimensionsRequired: 'Please fill in vehicle length and height',
      lengthMax: 'Vehicle length cannot exceed 20 m',
      widthMax: 'Vehicle width cannot exceed 5 m',
      heightMax: 'Vehicle height cannot exceed 5 m',
      heightWarning: 'Over-height vehicle, surcharge may apply',
      weightWarning: 'Heavy vehicle, please confirm carrier acceptance',
      vehicleTypes: {
        sedan: 'Sedan',
        suv: 'SUV',
        mpv: 'MPV',
        pickup: 'Pickup',
        truck: 'Truck',
        bus: 'Bus',
        machinery: 'Machinery',
        other: 'Other'
      }
    },

    bulkCargo: {
      title: 'Breakbulk Cargo Information',
      cargoKind: 'Cargo Type',
      tonnage: 'Tonnage (MT)',
      volume: 'Volume (CBM)',
      stowageFactor: 'Stowage Factor',
      packagingType: 'Packaging',
      remarks: 'Remarks',
      addCargo: 'Add Breakbulk Cargo',
      totalTonnage: 'Total Tonnage',
      totalVolume: 'Total Volume',
      averageStowageFactor: 'Average Stowage Factor',
      messages: {
        incomplete: 'Please complete breakbulk cargo information'
      },
      cargoKinds: {
        steel: 'Steel',
        coal: 'Coal',
        ore: 'Ore',
        grain: 'Grain',
        timber: 'Timber',
        fertilizer: 'Fertilizer',
        cement: 'Cement',
        sandStone: 'Sand/Stone',
        vehicle: 'Vehicle',
        other: 'Other'
      },
      packagingTypes: {
        bulk: 'Bulk',
        bag: 'Bag',
        bundle: 'Bundle',
        drum: 'Drum',
        pallet: 'Pallet',
        other: 'Other'
      }
    },

    // Placeholder texts
    placeholders: {
      autoGenerate: 'Auto Generate',
      selectInquiryNature: 'Select inquiry nature',
      selectBusinessType: 'Select business type',
      selectDeadline: 'Select quote deadline',
      selectPalletNature: 'Select pallet nature',
      selectCargoReadyTimeRange: 'Select cargo ready time range',
      selectCargoReadyDate: 'Select cargo ready date',
      selectOption: 'Please select',
      inputServiceTerm: 'Enter service term',
      selectClientType: 'Select client type',
      selectClient: 'Select client',
      inputClientTitle: 'Enter client title',
      selectRoute: 'Select route',
      selectLoadingPort: 'Select loading port',
      selectDestinationPort: 'Select port of discharge',
      selectDischargePort: 'Select discharge port',
      selectTransitPort1: 'Select first transit port',
      selectTransitPort2: 'Select second transit port',
      selectTransitPort3: 'Select third transit port',
      selectHazardClass: 'Select hazard class',
      inputUnNo: 'Enter UN No.',
      inputTemperature: 'Enter temperature',
      inputVentilation: 'Enter ventilation',
      enterInputQuantity: 'Enter quantity',
      inputWeight: 'Enter weight',
      inputDimensions: 'Enter dimensions',
      inputCargoDescription: 'Enter cargo description or HS Code',
      selectContainerRequirement: 'Select container requirement',
      selectTransportTerms: 'Select transport terms',
      inputCargoValue: 'Enter cargo value',
      selectCargoValueCurrency: 'Select currency',
      selectCarrier: 'Select carrier',
      inputFlightNo: 'Enter flight no.',
      inputRemarks: 'Enter remarks',
      province: 'Province',
      city: 'City',
      district: 'District',
      street: 'Street/Town',
      inputDetailAddress: 'Enter detail address',
      selectCountry: 'Select country',
      inputPostalCode: 'Enter or select postal code',
      inputDeliveryAddress: 'Enter detail address',
      selectAmazonWarehouse: 'Select Amazon warehouse',
      selectEcangWarehouse: 'Select Ecang warehouse',
      selectContainerType: 'Select container type',
      inputQuantity: 'Quantity',
      inputLoadingPointAddress: 'Enter loading point address',
      inputDeliveryAddressText: 'Enter delivery address',
      clickMatchPrice: 'Click "Query Matched Prices" to get price info',
      noFclMatches: 'No matching FCL prices found',
      noPrePortMatches: 'No matching preport prices found',
      noLastMileMatches: 'No matching last mile prices found',
      noFclPrices: 'No FCL prices',
      noPrePortPrices: 'No Preport prices',
      noLastMilePrices: 'No Last mile prices',
      quotePending: 'Quote pending',
      quoteRejected: 'Quote rejected',
      noFeeDetail: 'No fee detail',
      quotationStatus: 'Quotation Status',
      supplier: 'Supplier',
      allStatus: 'All Status',
      allSuppliers: 'All Suppliers',
      quoted: 'Quoted',
      imported: 'Imported'
    },

    // Inquiry nature enum
    inquiryNature: {
      pricing: 'Pricing',
      formal: 'Formal Inquiry'
    },

    // Business type enum
    businessType: {
      fcl: 'FCL',
      lcl: 'LCL',
      air: 'Air Freight',
      prePort: 'Pre-port',
      lastMile: 'Last Mile'
    },

    // Units and suffixes
    units: {
      celsius: '°C',
      kilogram: 'KGS'
    },

    // Messages
    messages: {
      originNodeRequired: 'Select at least one origin country, city, port, or airport',
      destinationNodeRequired: 'Select at least one destination country, city, port, or airport',
      prePortModeRequired: 'Select the pre-port transport mode and arrival node',
      prePortTruckAddressRequired: 'Select a warehouse or enter the trailer loading detail address',
      prePortBargeLoadingRequired: 'Select at least a loading city or loading seaport for barge transport',
      prePortRailLoadingRequired: 'Select at least a loading city or loading railway station for rail transport',
      prePortArrivalNodeRequired: 'Select at least an arrival country, city, or the port/station/airport for the selected node type',
      prePortAddressTypeRequired: 'Select the pre-port address type',
      prePortInlandPointRequired: 'Select a loading port for the inland-point pre-port address',
      prePortThirdPartyAddressRequired: 'Enter the pre-port third-party detail address',
      lastMileModeRequired: 'Select the last-mile transport mode and address type',
      lastMileOriginTypeRequired: 'Select the last-mile discharge node type',
      lastMileOriginNodeRequired: 'Select at least a discharge country, city, or the port/station/airport for the selected node type',
      lastMileTruckDestinationRequired: 'Select a warehouse or enter the third-party detail address for truck transport',
      lastMileBargeDestinationRequired: 'Select at least a destination country, city, or destination seaport for barge transport',
      lastMileRailDestinationRequired: 'Select at least a destination country, city, or destination railway station for rail transport',
      warehouseRequired: 'Select a warehouse master-data record',
      thirdPartyAddressRequired: 'Enter the third-party last-mile detail address',
      dangerousCargoRequired: 'Dangerous goods require UN number, hazard class, cargo name, and HS Code',
      cargoReadyTimeRequired: 'Select a complete cargo ready time',
      quoteDeadlineRequired: 'Select the quotation deadline',
      legacyAddressInfo: 'Legacy address information',
      legacyAddressReselect: 'Select a warehouse master-data record before submitting the edit',
      deliveryAddressReselect: 'Select a third-party address or warehouse before submitting',
      selectLoadingPortBeforeTerminal: 'Select the loading port first',
      noLinkedTerminal: 'No terminal or yard is linked to the selected loading port',
      saveDraftSuccess: 'Draft saved successfully',
      updateSuccess: 'Inquiry updated successfully',
      submitSuccess: 'Inquiry published successfully',
      saveFailed: 'Save failed',
      submitFailed: 'Publish failed',
      exportPending: 'Export rate function under development...',
      addressRecognitionSuccess: 'Address recognition successful',
      inputAddressFirst: 'Please enter address information',
      confirmSubmit: 'Confirm to publish?',
      confirm: 'Confirm',
      cancel: 'Cancel',
      loading: 'Loading...',
      noData: 'No data',
      detailNotFound: 'Inquiry detail not found',
      loadDetailFailed: 'Failed to load inquiry detail',
      confirmSupplierSuccess: 'Supplier confirmed successfully',
      confirmSupplierFailed: 'Failed to confirm supplier',
      supplierConfirmSuccess: 'Supplier confirmed successfully',
      supplierConfirmFailed: 'Failed to confirm supplier, please try again',
      cancelConfirmSuccess: 'Confirmation cancelled successfully',
      cancelConfirmFailed: 'Failed to cancel confirmation',
      supplierCancelConfirmSuccess: 'Supplier confirmation cancelled',
      supplierCancelConfirmFailed: 'Failed to cancel confirmation, please try again',
      resetFailed: 'Reset failed, please try again',
      requiredFieldsMissing: 'Please fill in required fields',
      doorPostalCodeRequired: 'Postal code is required when transport terms end with DOOR',
      doorDeliveryAddressRequired: 'Delivery detail address is required when transport terms end with DOOR',
      quoteTextUnavailable: 'Unable to get quotation text content',
      orderAlreadyGenerated: 'This inquiry has already generated an order and cannot be booked again',
      quotationMissingForBooking: 'Quotation information does not exist, booking cannot be initiated',
      bookingFailed: 'Booking confirmation failed',
      copySuccess: 'Text copied to clipboard',
      copyFailed: 'Copy failed, please copy manually',
      noAvailablePrices: 'No available price information found. Please query and select matched prices, or wait for new quotations.',
      selectQuotedPriceFirst: 'Please select a quoted price first',
      loadTemplateFailed: 'Failed to load template',
      openTemplateViewReportFailed: 'Failed to open template view report',
      inquiryAllDisabled: 'At least one of trunk line, pre-port and last mile prices must be enabled',
      trunkOriginPortRequired: 'Enter at least one trunk-line origin country, location, or port',
      trunkDestinationPortRequired: 'Enter at least one trunk-line destination country, location, or port of discharge',
      trunkOriginAirportRequired: 'Enter at least one trunk-line origin country, location, or airport',
      trunkDestinationAirportRequired: 'Enter at least one trunk-line destination country, location, or airport',
      routeMatchSuccess: 'Route matched successfully',
      routeMatchFailed: 'No matching route found',
      addressRecognitionFailed: 'Address recognition failed',
      cargoDescriptionRequired: 'Cargo description is required when transport terms end with DOOR',
      cargoValueRequired: 'Cargo value is required when service term is DDP or transport terms end with DOOR',
      cargoValueCurrencyRequired: 'Cargo value currency is required when service term is DDP or transport terms end with DOOR',
      rfTemperatureStartRequired: 'Start temperature is required',
      rfTemperatureEndRequired: 'End temperature is required',
      rfVentilationEnableRequired: 'Ventilation door is required',
      rfVentilationQuantityRequired: 'Air flow is required',
      loadingPortSameAsDestination: 'The port of loading and port of discharge cannot be the same',
      destinationPortSameAsLoading: 'The port of discharge and port of loading cannot be the same'
    },

    consignmentLink: {
      title: 'Link Consignment',
      searchPlaceholder: 'Enter consignment no. to search',
      search: 'Search',
      link: 'Link',
      columns: {
        consignmentNo: 'Consignment No.',
        businessType: 'Business Type',
        route: 'Route',
        cargo: 'Cargo',
        status: 'Status',
        actions: 'Actions'
      },
      messages: {
        selectQuotation: 'Please select one quoted quotation',
        noPermission: 'Consignment linking is not allowed on this page',
        searchFailed: 'Failed to search consignments',
        linkSuccess: 'Consignment linked successfully',
        linkFailed: 'Failed to link consignment',
        entrustedDisabled: 'Entrusted consignments cannot be linked'
      }
    },

    quotationTable: {
      title: 'Supplier Quotations',
      quoteCount: '{quoted}/{total} quoted',
      cancelConfirm: 'Cancel Confirmation',
      confirmSupplier: 'Confirm Supplier',
      linkConsignment: 'Link Consignment',
      empty: 'No supplier quotations',
      columns: {
        bpmStatus: 'Status',
        supplier: 'Supplier',
        quotationNo: 'Quotation No.',
        plan: 'Plan',
        transitDays: 'Transit Days',
        amount: 'Amount',
        prePortFee: 'Pre-port Fee',
        trunkLineFee: 'Main-leg Fee',
        lastMileFee: 'Last-mile Fee',
        totalFee: 'Total Fee',
        validUntil: 'Valid Until',
        submitDate: 'Quoted At',
        quotationStatus: 'Quotation Status',
        confirmStatus: 'Confirmation Status',
        consultationStatus: 'Negotiation Status',
        importStatus: 'Import Status',
        negotiation: 'Negotiation',
        actions: 'Actions'
      },
      status: {
        imported: 'Imported',
        notImported: 'Not Imported',
        quoted: 'Quoted',
        notQuoted: 'Not Quoted',
        confirmed: 'Confirmed',
        unconfirmed: 'Unconfirmed',
        notConsulted: 'Not Negotiated',
        consulting: 'Negotiating',
        consultationCompleted: 'Negotiation Completed',
        pendingConfirm: 'Pending'
      },
      plan: {
        prefix: 'Plan ',
        onePrice: 'All In Price',
        direct: 'Direct',
        transit: 'Transit',
        unspecified: 'Unspecified'
      },
      actions: {
        viewDetail: 'View Details',
        negotiate: 'Negotiate',
        continueNegotiate: 'Continue Negotiation',
        import: 'Import'
      },
      negotiation: {
        recordsTitle: 'Negotiation Records',
        currentPrice: 'Current Quote',
        empty: 'No negotiation records',
        round: 'Round {index}',
        expectedPrice: 'Expected Price',
        note: 'Negotiation Note',
        status: 'Status',
        pending: 'Pending Reply',
        replied: 'Replied',
        accepted: 'Accepted',
        rejected: 'Rejected',
        replyPrice: 'Reply Price',
        replyNote: 'Reply Note',
        changeContent: 'Change Content'
      },
      importConfirm: {
        title: 'Confirm Import',
        content: 'Import the quotation from "{supplier}" to the price library?'
      },
      messages: {
        importSuccess: 'Imported to price library successfully',
        importFailed: 'Failed to import to price library',
        selectQuotation: 'Please select one quotation plan'
      }
    },

    combinationModal: {
      previewCount: '{count} rate records will be created by service segment',
      previewFailed: 'Could not load the import preview. Close this dialog and try again.',
      segments: { prePort: 'Pre-port', trunk: 'Main leg', lastMile: 'Last mile' },
      warehouses: { prePort: 'Pre-port rate warehouse', fcl: 'FCL rate warehouse', lcl: 'LCL rate warehouse', air: 'Air rate warehouse', lastMile: 'Last-mile rate warehouse' },
      title: 'Select Combination Type',
      description: 'A single segment defaults to free combination. Choose free or precise combination, then confirm to import directly.',
      fixedTip: 'Multi-segment quotations require precise combination and are imported directly after confirmation.',
      confirm: 'Confirm Import'
    },

    quotationDetailModal: {
      title: 'Quotation Details - {supplier}',
      titleWithQuotationNoOnly: 'Quotation Details ({quotationNo})',
      titleWithQuotationNo: 'Quotation Details - {supplier} ({quotationNo})',
      fields: {
        transportMode: 'Transport Mode',
        transitDays: 'Transit Days',
        validUntil: 'Valid Until'
      },
      combination: {
        free: 'Free combination',
        precise: 'Precise combination'
      },
      sections: {
        trunkLineFreight: 'Main-leg Freight',
        trunkLineBaseFee: 'Main-leg Base Fee',
        trunkLineSurcharge: 'Main-leg Surcharge',
        originPortFee: 'Origin Port Fee',
        destinationPortFee: 'Destination Port Fee',
        prePortFee: 'Pre-port Fee',
        prePortBaseFee: 'Pre-port Base Fee',
        prePortSurcharge: 'Pre-port Surcharge',
        lastMileFee: 'Last-mile Fee',
        lastMileBaseFee: 'Last-mile Base Fee',
        lastMileSurcharge: 'Last-mile Surcharge',
        otherFee: 'Surcharge',
        potentialFee: 'Potential Fee',
        totalFee: 'Total Fee'
      },
      columns: {
        containerType: 'Container Type',
        feeItem: 'Fee Item',
        feeDetail: 'Fee Details',
        unitPrice: 'Unit Price',
        quantity: 'Quantity',
        unit: 'Unit',
        billingUnit: 'Billing Unit',
        subtotal: 'Subtotal',
        lclOceanFreight: 'LCL Ocean Freight',
        airFreight: 'Air Freight',
        truckingFee: 'Trucking Fee',
        truckDeliveryFee: 'Truck Delivery Fee'
      },
      units: {
        container: 'Container'
      },
      actions: {
        close: 'Close',
        import: 'Import to Price Library',
        imported: 'Imported to Price Library'
      },
      transportMode: {
        direct: 'Direct',
        transit: 'Transit',
        ocean: 'Ocean',
        air: 'Air',
        land: 'Land'
      },
      messages: {
        loadFailed: 'Failed to load quotation details',
        importSuccess: 'Imported to price library successfully',
        importFailed: 'Failed to import to price library'
      }
    },

    bpm: {
      bannerTitle: 'Quotation Confirmation Approval',
      bannerApproved: 'BPM approval passed',
      bannerApprovedTail: 'You can now send the award notice',
      bannerPending: 'BPM approval initiated',
      bannerPendingTail: 'Award notice can be sent after approval',
      bannerRejected: 'BPM approval rejected. Please adjust and resubmit.',
      statusLabel: 'Approval Status',
      awardedSupplier: 'Awarded Supplier',
      awardNoticeSent: 'Award notice sent',
      totalCost: 'Total Quoted Cost',
      viewApproval: 'View Approval',
      pendingStatusTag: 'In Approval',
      submit: 'Submit for Approval',
      withdraw: 'Withdraw Approval',
      submitTitle: 'Submit Quotation Confirmation',
      selectQuotation: 'Select Quotation',
      selectQuotationPlaceholder: 'Select a quotation to submit',
      selectQuotationRequired: 'Please select a quotation',
      selectedSupplier: 'Selected Supplier',
      selectedTotal: 'Selected Total',
      relatedInquiryNo: 'Related Inquiry No.',
      selectedSupplierLabel: 'Selected Supplier',
      selectedSuppliersEmpty: 'Please select a quotation in the table first',
      totalCostLabel: 'Total Quoted Cost',
      remark: 'Remark',
      remarkPlaceholder: 'Optional remark',
      workflowLabel: 'Approval Workflow',
      workflowName: 'Quotation Confirmation Workflow',
      withdrawTitle: 'Withdraw Approval',
      withdrawTip: 'After withdrawal you can re-select and submit. Cannot withdraw after award notice is sent.',
      withdrawConfirmTitle: 'Confirm Withdrawal',
      withdrawConfirmContent: 'Are you sure you want to withdraw this approval?',
      useBpmInstead: 'BPM approval is enabled. Please use "Submit for Approval" above.',
      bpmConfirmPending: 'In Approval',
      bpmConfirmWinner: 'Awarded'
    },

    awardNotice: {
      title: 'Send Award Notice Email',
      send: 'Send',
      sendEmail: 'Send Email',
      confirmSend: 'Confirm Send',
      previewBtn: 'Preview Award Notice',
      downloadBtn: 'Download',
      attachmentGenerating: 'Generating award notice...',
      sendBtn: 'Send Award Notice',
      previewTitle: 'Award Notice Preview',
      previewEmpty: 'No preview available',
      receiverEmail: 'Recipient Email',
      receiverEmails: 'To',
      receiverEmailPlaceholder: 'Enter recipient email',
      receiverEmailsPlaceholder: 'Enter an email address and press Enter; separate multiple emails with comma or semicolon',
      receiverEmailRequired: 'Please enter at least one recipient email',
      receiverEmailInvalid: 'Invalid recipient email format: {email}',
      ccEmails: 'CC',
      ccEmailsPlaceholder: 'Optional; separate multiple emails with comma or semicolon',
      ccEmailInvalid: 'Invalid CC email format: {email}',
      subject: 'Subject',
      subjectPlaceholder: 'Please enter email subject',
      subjectRequired: 'Please enter email subject',
      content: 'Content',
      contentRequired: 'Please enter email content',
      attachment: 'Attachment',
      /** Attachment display name (shown to users in the dialog) */
      attachmentName: '【Award Notice】.pdf',
      attachmentMissing: 'Award notice attachment is not yet generated, please try again later',
      preview: 'Preview',
      templateTipTitle: 'Email template',
      templateTip: 'Email content has been generated from "{name}"',
      templateConfigLink: 'Configure',
      quotationRequired: 'No awarded supplier confirmed, cannot send award notice',
      sendSuccess: 'Award notice email sent successfully',
      sendFailed: 'Failed to send award notice email',
      templateMissing: 'Please maintain the Award Notice V3 template in template configuration first'
    },

    bpmApproval: {
      back: 'Back',
      title: 'Inquiry BPM Approval',
      tcFeeTitle: 'Reconciliation BPM Approval',
      tcFeeDetailUnavailable: 'Please complete the approval in the right panel.',
      tcFee: {
        infoTitle: 'Fee Review Info',
        reconciliationNo: 'Reconciliation No.',
        consignmentNo: 'Consignment No.',
        supplierName: 'Reconciliation Supplier',
        billStatus: 'Bill Status',
        originalTotal: 'Original Quote Total',
        currentTotal: 'Reconciliation Total',
        diffNoteTitle: 'Supplier Difference Note',
        compareTitle: 'Fee Comparison',
        noFeeDetail: 'No fee details',
        batchApprove: 'Approve All Minor Diffs',
        warningTip: '{count} fee item(s) have large differences, please review carefully',
        minorTip: '{count} fee item(s) are minor differences and can be approved quickly',
        rejectLabel: 'Reject',
        colCategory: 'Category',
        colName: 'Fee Name',
        colCurrency: 'Currency',
        colOriginalAmount: 'Original Amount',
        colCurrentAmount: 'Reconciliation Amount',
        colDiffAmount: 'Difference',
        colDiffRate: 'Diff Rate',
        batchConfirmTitle: 'Approve all minor differences?',
        batchConfirmContent: 'All {count} differences are below {currency} {amount} with a diff rate under {rate}%. Confirming will approve this fee review directly.',
        batchOk: 'Approve',
        batchCancel: 'Cancel',
        batchSuccess: 'Minor differences approved',
        batchNoAction: 'No approve action available at the current node',
        batchFailed: 'Failed to batch approve minor differences',
        batchRemark: 'Batch approve minor differences: {count} fee diffs are all below {currency} {amount} with a diff rate under {rate}%'
      },
      awardSummary: 'Award Summary',
      missingParams: 'Missing approval parameters',
      flowInfo: 'Workflow Info',
      flowNo: 'Workflow No.',
      flowName: 'Workflow Name',
      initiator: 'Initiator',
      applyTime: 'Start Time',
      currentApprover: 'Current Approver',
      relatedDoc: 'Related Document',
      approvalNotes: 'Approval Notes',
      noApprovalNotes: 'No approval notes',
      progress: 'Approval Progress',
      attachments: 'Approval Attachments',
      noAttachments: 'No attachments',
      defaultFlowName: 'Quote Confirmation Approval',
      progressSubmit: 'Submit Quote Confirmation Approval',
      progressManager: 'Manager Approval',
      progressFinance: 'Finance Director Approval',
      actions: 'Actions',
      noActions: 'No actions available',
      remark: 'Remark',
      remarkPlaceholder: 'Enter approval remark (optional)',
      history: 'Approval History',
      loadFailed: 'Failed to load approval info',
      approve: 'Approve',
      reject: 'Reject',
      return: 'Return',
      rollback: 'Rollback',
      cancel: 'Cancel',
      confirmTitle: 'Confirm Action',
      confirmContent: 'Proceed with "{action}"?',
      actionSuccess: 'Action completed',
      actionFailed: 'Action failed',
      download: 'Download',
      downloadFailed: 'Download failed'
    },

    consultationModal: {
      title: 'Start Consultation',
      supplier: 'Supplier',
      quotationPlan: 'Quotation Plan',
      currentPrice: 'Current Quote',
      expectedPrice: 'Expected Price',
      expectedPricePlaceholder: 'Enter expected price, e.g. USD 2500',
      note: 'Consultation Note',
      notePlaceholder: 'Enter consultation note, such as items to adjust or reasons',
      messages: {
        expectedPriceRequired: 'Please enter expected price',
        quotationIdMissing: 'Quotation ID does not exist',
        submitSuccess: 'Consultation submitted successfully',
        submitFailed: 'Failed to submit consultation'
      }
    }
  },

  // ======== Shokz AI Inquiry Recognition Inline Panel ========
  shokzAiInquiryRecognition: {
    title: 'AI Recognition Autofill',
    upload: {
      title: 'Click or drag to upload inquiry file',
      supportedFormats: 'Supports JPG/PNG/PDF/Excel/Word formats'
    },
    warning: 'If only inquiring about pre-port and last-mile charges, please clearly mark "Pre-port" and "Last-mile" respectively.',
    textPlaceholder: `Please paste the inquiry text, for example:
FCL/LCL: From CNSHA/Shanghai to USLAX/Los Angeles
Carrier: Maersk
Container: 2x20GP + 1x40HC
Weight: 1200 KGS
CBM: 6.5
Service terms: DDP
Cargo type: General Cargo
HS Code: 85183000

Air: From PVG/Shanghai Pudong Airport to LAX/Los Angeles Airport
Flight No: CA123
Pieces: 20 CTNS
Weight: 320 KGS
CBM: 1.8

Pre-port: Pre-port loading location in Shanghai Pudong, port of loading CNSHA Shanghai

Last-mile: Last-mile destination port NLRTM Rotterdam, third-party delivery address in Los Angeles, CA

RORO/Bulk: RORO SUV quantity 2; or break bulk 10 packages, 5000 KGS, 20 CBM`,
    startButton: 'Start Recognition',
    messages: {
      emptyInput: 'Please upload a file or enter text content',
      error: 'AI recognition failed, please try again',
      filledCount: 'AI recognition completed, {filled} fields filled',
      noResult: 'No valid information recognized, please check input'
    }
  },

  // ======== Shokz Quote Compare ========
  shokzQuoteCompare: {
    pageTitle: 'Quote Compare',
    quoteCount: 'Quote Count',
    quotationList: 'Quotation List',
    sortedByAmount: 'Sorted by amount (ascending)',
    confirmTitle: 'Confirm to Price Library',
    confirmWarning: 'After confirmation, this quotation will be saved to the price library, and the inquiry status will change to "Confirmed". Continue?',
    supplier: 'Supplier',
    totalAmount: 'Total Amount',
    loadFailed: 'Failed to load quotation data',
    onlyQuotedCanConfirm: 'Only quoted status can be confirmed',
    confirmSuccess: 'Confirmed successfully',
    confirmFailed: 'Confirmation failed',
    columns: {
      supplier: 'Supplier',
      contact: 'Contact',
      carrier: 'Carrier',
      directTransit: 'Direct/Transit',
      transitDays: 'Transit Days',
      baseFreight: 'Base Freight',
      extraFees: 'Extra Fees',
      totalAmount: 'Total Amount',
      validUntil: 'Valid Until',
      status: 'Status',
      action: 'Action'
    },
    basicInfo: {
      inquiryNo: 'Inquiry No.',
      inquiryNature: 'Inquiry Nature',
      loadingPort: 'Loading Port',
      dischargePort: 'Port of Discharge (POD)',
      carrier: 'Carrier',
      cargoReadyTime: 'Cargo Ready Time',
      containerTypes: 'Containers'
    },
    actions: {
      confirm: 'Confirm'
    }
  },

  // ======== Shokz Address Allocation Modal ========
  shokzAddressAllocModal: {
    title: 'Address Allocation',
    description: 'The following address cannot be automatically identified. Please manually allocate:',
    unknownAddress: 'Address',
    selectPlaceholder: 'Please select',
    options: {
      stuffing: 'Pre-port Stuffing Point',
      delivery: 'Last-mile Delivery Address'
    },
    cancel: 'Cancel',
    confirm: 'Confirm Backfill'
  }
}
